import { useRef } from "react";
import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { formatDate } from "@/lib/format";

export default function LatestUpdates() {
  const scrollerRef = useRef<HTMLDivElement>(null);

  const latest = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );

  const scrollBy = (direction: number) => {
    scrollerRef.current?.scrollBy({ left: direction * 560, behavior: "smooth" });
  };

  return (
    <section className="w-full py-12 bg-background-100/60 border-y border-background-200">
      <div className="px-4 md:px-6">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
              <i className="ri-flashlight-fill text-primary-500" />
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-500">追更不错过，最新章节实时同步</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollBy(-1)}
              className="w-9 h-9 rounded-full bg-background-100 border border-background-200 text-foreground-700 flex items-center justify-center hover:text-primary-500 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => scrollBy(1)}
              className="w-9 h-9 rounded-full bg-background-100 border border-background-200 text-foreground-700 flex items-center justify-center hover:text-primary-500 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
          </div>
        </div>

        <div
          ref={scrollerRef}
          className="flex gap-4 overflow-x-auto no-scrollbar pb-2"
        >
          {latest.map((comic) => {
            const chapter = comic.chapters[comic.chapters.length - 1];
            return (
              <Link
                key={comic.id}
                to={`/detail/${comic.id}`}
                className="group shrink-0 w-[260px] flex gap-3 p-3 rounded-lg bg-background-100 border border-background-200 hover:border-primary-400 transition-all duration-300"
              >
                <div className="w-[72px] h-[96px] rounded-md overflow-hidden shrink-0">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} 最新更新封面`}
                    title={`${comic.title} 最新章节`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-700 truncate">
                    第 {chapter.number} 话 · {chapter.title}
                  </p>
                  <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line" />
                    {formatDate(comic.updatedAt)}
                  </p>
                  <span className="mt-2 inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] bg-accent-100 text-accent-900">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                    已更新
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}